import { render } from "./Navigation.vue?vue&type=template&id=651dbc96&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=651dbc96&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-651dbc96"

export default script